// eslint-disable-next-line import/prefer-default-export
export const entityActionEnum = {
  addEntity: 'add_entity',
  updateEntity: 'update_entity',
  archiveEntity: 'archive_entity',
  restoreEntity: 'restore_entity'
};
